import React from 'react'
import PropTypes from 'prop-types'
import './CategoriesView.scss'

import CONFIG from '../../../config'
import {PRODUCT_TYPES} from "../../../constants";

import {getLanguageScope} from '../../../helpers'
const _i18n = getLanguageScope('categories');

import {Card, Image} from 'semantic-ui-react'
import _ from 'lodash'

import CategoryDefaultImage from '../../../assets/category_default_image.png'
import {loadSingleProducts} from "../../Products/modules/products";

class CategoriesView extends React.Component {
  constructor(props) {
    super(props);

    this.renderItems = this.renderItems.bind(this);
    this.launchApplication = this.launchApplication.bind(this);
  }

  componentDidMount() {
    const {categories, loadCategories, singleProducts, loadSingleProducts} = this.props;

    if (!(categories && categories.length)) {
      loadCategories();
    }

    if(!(singleProducts && singleProducts.length)){
      loadSingleProducts();
    }
  }

  selectCategory(category_id){
    const {next} = this.props;

    return next(category_id);
  }

  launchApplication(app_guid, product_id){
    const {launchApplication} = this.props;

    return launchApplication(app_guid, product_id);
  }

  createIcon(icon, category_name){
    if(!(category_name && _.isString(category_name))) return;

    let result = CategoryDefaultImage;

    if(/bill payment/.test(category_name.toLowerCase())){
      result = require('../../../assets/category_icons/ic_payanybill.png')
    }

    if(/pay any bill/.test(category_name.toLowerCase())){
      result = require('../../../assets/category_icons/ic_payanybill.png')
    }

    if(/international topup/.test(category_name.toLowerCase())){
      result = require('../../../assets/category_icons/ic_internationaltopup.png')
    }

    if(/pin product/.test(category_name.toLowerCase())){
      result = require('../../../assets/category_icons/ic_pinproducts.png')
    }

    if(/phone reload|mobile prepaid|mobile plan/.test(category_name.toLowerCase())){
      result = require('../../../assets/category_icons/ic_phonereload.png')
    }

    if(icon){
      result = `${CONFIG.STATIC_PATH}/${icon}`
    }

    return result;
  }

  сreateSingleProductIcon(icon, name){

    let result = `${CONFIG.STATIC_PATH}/${icon}`;

    if(name){
      if(/card reload/.test(name.toLowerCase())){
        result = require('../../../assets/category_icons/ic_card_reload.png')
      }

      if(/check/.test(name.toLowerCase())){
        result = require('../../../assets/category_icons/ic_card_reload.png')
      }
    }

    return result;
  }

  renderItems() {

    let categoriesViews = [
      <Card onClick={() => this.selectCategory(PRODUCT_TYPES.BILLPAYMENT)} as='a' key={PRODUCT_TYPES.BILLPAYMENT}>
        <Image fluid centered src={require(`../../../assets/category_icons/ic_payanybill.png`)}/>
        <Card.Content>
          <Card.Header className='category-title'>{_i18n('pay_any_bill')}</Card.Header>
        </Card.Content>
      </Card>,

      <Card onClick={() => this.selectCategory(PRODUCT_TYPES.PHONERELOAD_US)} as='a' key={PRODUCT_TYPES.PHONERELOAD_US}>
        <Image fluid centered src={require(`../../../assets/category_icons/ic_phonereload.png`)}/>
        <Card.Content>
          <Card.Header className='category-title'>{_i18n('phone_reload')}</Card.Header>
        </Card.Content>
      </Card>,

      <Card onClick={() => this.selectCategory(PRODUCT_TYPES.PIN_PRODUCTS)} as='a' key={PRODUCT_TYPES.PIN_PRODUCTS}>
        <Image fluid centered src={require(`../../../assets/category_icons/ic_pinproducts.png`)}/>
        <Card.Content>
          <Card.Header className='category-title'>{_i18n('pin_products')}</Card.Header>
        </Card.Content>
      </Card>,

      <Card onClick={() => this.selectCategory(PRODUCT_TYPES.PHONERELOAD_INTERNATIONAL)} as='a' key={PRODUCT_TYPES.PHONERELOAD_INTERNATIONAL}>
        <Image fluid centered src={require(`../../../assets/category_icons/ic_internationaltopup.png`)}/>
        <Card.Content>
          <Card.Header className='category-title'>{_i18n('international_topup')}</Card.Header>
        </Card.Content>
      </Card>
    ];

    const {categories} = this.props;

    categoriesViews = _.union(categoriesViews, _.map((categories||[]), ({icon, category_name, category_id}, key) => {
      let image = this.createIcon(icon, category_name);

      return (
        <Card onClick={() => this.selectCategory(category_id)} as='a' key={key}>
          <Image fluid centered src={image}/>
          <Card.Content>
            <Card.Header className='category-title'>{category_name}</Card.Header>
          </Card.Content>
        </Card>
      )
    }));

    const {singleProducts} = this.props;

    categoriesViews = _.union(categoriesViews, _.map((singleProducts||[]), ({icon, title, app_guid, product_id}, key) => {
      let image = this.сreateSingleProductIcon(icon, title);

      return (
        <Card onClick={() => this.launchApplication(app_guid, product_id)} as='a' key={`single_${key}`}>
          <Image fluid centered src={image}/>
          <Card.Content>
            <Card.Header className='category-title'>{title}</Card.Header>
          </Card.Content>
        </Card>
      )
    }));

    return categoriesViews;
  }

  render() {
    return <Card.Group itemsPerRow={5} stackable={true}> {this.renderItems()} </Card.Group>
  }
}

CategoriesView.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.object),
  setLoadingContent: PropTypes.func,
  next: PropTypes.func
};

export default CategoriesView


// WEBPACK FOOTER //
// ./src/components/Categories/components/CategoriesView.js